import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import React from "react";
import { t } from "ttag";

import { CompareTileBlock } from "@reactivated";

import { RichText } from "../../../common/RichText";
import { DropdownHeadersType } from "../../../templates/ShopTileTemplate";

import styles from "./index.module.scss";

interface IDropdownProps {
    dropdownHeaders: DropdownHeadersType;
    selectedProduct?: CompareTileBlock["compare_tile"];
    handleSelectProduct?: (oldTile: number, newTile: number) => void;
    selectedProducts?: number[];
}

export const Dropdown = (props: IDropdownProps) => {
    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                <button className={styles.trigger}>
                    {props.selectedProduct ? (
                        <RichText html={props.selectedProduct.title || ""} />
                    ) : (
                        <span>{t`Select Model`}</span>
                    )}
                </button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content className={styles.menu} sideOffset={8}>
                    {props.dropdownHeaders.map((product, index) => (
                        <div
                            key={`${index}-${product.id}`}
                            className={styles.group}
                        >
                            <DropdownMenu.Group>
                                <DropdownMenu.Label className={styles.label}>
                                    <RichText html={product?.header || ""} />
                                </DropdownMenu.Label>
                                {product.children?.map((child) => {
                                    const compareTile = child.compare_tile;
                                    return (
                                        compareTile && (
                                            <DropdownMenu.Item
                                                key={compareTile.product}
                                                className={`${styles.item} ${compareTile.product === props.selectedProduct ? "selected" : ""}`}
                                                onSelect={() => {
                                                    if (
                                                        !compareTile.disabled &&
                                                        props.handleSelectProduct &&
                                                        props.selectedProduct
                                                            ?.product &&
                                                        compareTile.product
                                                    )
                                                        props.handleSelectProduct(
                                                            props
                                                                .selectedProduct
                                                                ?.product,
                                                            compareTile.product,
                                                        );
                                                }}
                                                disabled={compareTile.disabled}
                                            >
                                                <RichText
                                                    html={
                                                        compareTile?.title || ""
                                                    }
                                                />
                                            </DropdownMenu.Item>
                                        )
                                    );
                                })}
                            </DropdownMenu.Group>
                        </div>
                    ))}
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};
